import styled from "styled-components";
import TextField from "@material-ui/core/TextField";

export const ControlBnts = styled.div`
  display: flex;
  width: 100%;
`;

export const MUITextField = styled(TextField)`
  && {
    .MuiOutlinedInput-root {
        height: 100%;
    }
    height: 36px;
    margin-left: -5px;

    fieldset {
      width: 80%;
    }

    input {
      padding-left: 5px;
    }
  }
`;
